/**
 * El aviso de «Vincular columnas» cuando ninguna columna del archivo de clientes dice quién aceptó recibir mensajes.
 *
 * Sin esa columna, todos quedan «sin dato». Reactivación, con la política «declarada» (la de casi todas las marcas),
 * les escribe igual por las líneas y por email; WhatsApp oficial no le escribe a nadie, y eso se descubría recién al
 * confirmar la campaña oficial («no hay a quién mandarle»), después de la plantilla y la prueba. Acá todavía se puede
 * elegir la columna, si el auto-mapeo la ignoró, o volver con un archivo que la tenga.
 */

/**
 * El campo del mapeo que dice quién aceptó (`CAMPOS.clientes` de `backend/.../activa/services/mapping.util.ts`). Un
 * test del backend (`tests/activa/mapping.util.test.ts`) se pone rojo si allá cambia el nombre: con otro nombre, este
 * aviso saldría siempre.
 */
export const CAMPO_CONSENTIMIENTO = "Opt-in (consentimiento)";

/**
 * ¿Alguna columna de clientes quedó asignada al consentimiento? Con el MISMO valor que muestra el select de la columna:
 * lo que eligió el operador o, si no tocó nada, la sugerencia.
 */
export function hayColumnaDeConsentimiento(
  sugerencia: { columnaCliente: string; campoDeenex?: string }[] | null | undefined,
  mapeoClientes: Record<string, string> | null | undefined,
): boolean {
  return (sugerencia || []).some((s) => (mapeoClientes?.[s.columnaCliente] ?? s.campoDeenex) === CAMPO_CONSENTIMIENTO);
}

export function avisoSinColumnaConsentimiento(): { titulo: string; detalle: string } {
  return {
    titulo: "Ninguna columna dice quién aceptó recibir mensajes",
    detalle:
      "Por WhatsApp oficial sólo se le puede escribir a quien aceptó: con este archivo serían 0 personas. " +
      `Si el archivo tiene esa columna, elegila arriba como «${CAMPO_CONSENTIMIENTO}». ` +
      "Si no, agregala (sí o no) o cargá los contactos con su consentimiento.",
  };
}

/**
 * La línea del paso de envío que dice a quién se saltea por el consentimiento. Decía siempre «se saltea a quien no dio
 * consentimiento», y con la política «declarada» (la de casi todas las marcas) a quien el archivo no dice si aceptó
 * se le escribe igual: sólo se saltea a quien dijo que no (`send`, gate legal, en `activa.service.ts`). Sin saber la
 * política, lo que vale siempre.
 */
export function queSeSalteaPorConsentimiento(politica: "estricta" | "declarada" | null | undefined): string {
  if (politica === "declarada") {
    return "Se saltea a quien pidió la baja y a quien dijo que no. A quien el archivo no dice si aceptó le escribe igual, porque tu marca declaró tener su permiso.";
  }
  if (politica === "estricta") return "Se saltea a quien pidió la baja y a quien no dijo que sí.";
  return "Se saltea a quien pidió la baja y a quien dijo que no. A quien el archivo no dice si aceptó, según el permiso que declaró tu marca.";
}
